<template>

  <t-loading theme="spinner" text="加载中..." :loading="isLoading" fullscreen />
  <div class="page">
    <!-- 顶部用户信息 -->

    <div class="top-box" v-if="!isLoading">
      <t-cell :image="customerInfo.avatarUrl" @click="goEditCustomer" :title="customerInfo.name"
        :description="customerInfo.mobile" note="" />
    </div>



    <!-- 中部数据列表 -->
    <div class="mid-box">
      <t-cell-group>
        <!-- 可点击项（带箭头） -->
        <t-cell title="订单" arrow @click="goCustomerOrderList" :note="customerInfo.sum.order" hover />
        <t-cell title="积分" arrow hover @click="goCustomerPointList" :note="customerInfo.point" />
        <t-cell title="储值" arrow hover @click="goCustomerStoreAmountList"
          :note="`¥ ${customerInfo.storeAmount / 100}`" />
        <t-cell title="赠值" arrow hover @click="goCustomerZengAmountList" :note="`¥ ${customerInfo.zengAmount / 100}`" />
        <t-cell title="次卡" arrow hover @click="goCustomerCardList" :note="customerInfo.sum.cika" />
        <t-cell title="打折卡" arrow hover @click="goCustomerCardList2" :note="customerInfo.sum.discount" />
        <t-cell title="优惠券" arrow hover @click="goCustomerCouponList" :note="customerInfo.sum.coupon" />
        <t-cell title="标签" arrow @click="goCustomerSign" :note="customerSign" />

        <!-- 纯展示项（无箭头） -->
        <t-cell title="总消费" hover :note="`¥ ${customerInfo.totalConsumAmount / 100}`" />
        <t-cell title="回访记录" arrow hover @click="goCustomerFolllowLog" :note="customerInfo.sum.follow" />
        <t-cell title="预约记录" arrow hover @click="goCustomerAppointmentLog" />
        <t-cell title="归属顾问" hover :note="customerInfo.consultant" />
        <t-cell title="最后消费时间" hover :note="customerInfo.lastConsumAt" />
        <t-cell title="创建时间" hover :note="customerInfo.createAt.time3" />
      </t-cell-group>
    </div>

    <!-- 底部操作栏 -->
    <div class="foot-box">
      <t-grid :column="5">
        <t-grid-item @click="goRecharge" text="充值" :image="chongzhiImg" />
        <t-grid-item @click="goSendCard" text="充次" :image="idcardImg" />
        <t-grid-item @click="goSendCoupon" text="发券" :image="youhuiquanImg" />
        <t-grid-item @click="goFollow" text="回访" :image="huifangImg" />
        <t-grid-item @click="goCasher" text="开单" :image="kaidanImg" />
      </t-grid>
    </div>
  </div>


  <t-dialog :visible="showUserAction" title="未找到客户信息" button-layout="vertical" @cancel="showUserAction = false">

    <template #content>
      <t-button style="margin-top:5vw" theme="light" block @click="() => handleUserActionSelected(1)">绑定已有客户</t-button>
      <t-button style="margin-top:5vw" theme="light" block @click="() => handleUserActionSelected(0)">注册新客户</t-button>
    </template>
  </t-dialog>

</template>


<script setup>
import {
  ref,
  getCurrentInstance,
  onMounted,
  reactive
} from 'vue'
import * as ww from '@wecom/jssdk'
import chongzhiImg from '@/assets/chongzhi.png'
import idcardImg from '@/assets/idcard.png'
import youhuiquanImg from '@/assets/youhuiquan.png'
import huifangImg from '@/assets/huifang.png'
import kaidanImg from '@/assets/kaidan.png'
import axios from 'axios';
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();
import { stateCustomer, stateShop, stateReloadCustomer, stateCategoryList, stateUser } from '@/store'
import { Toast } from 'tdesign-mobile-vue'
const { proxy } = getCurrentInstance();

const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
const auth = proxy.$auth;

const showUserAction = ref(false);

const someWarnInfo = ref('');

const isLoading = ref(true);



const work_weixin_user = reactive({

  external_userid: '',
  name: '',
  avatar: '',
  unionid: ''

})
// 用户数据（示例）
const customerInfo = reactive({
  avatarUrl: '',
  name: '',
  mobile: '',
  sum: {
    order: 0,
    cika: 0,
    discount: 0,
    coupon: 0,
    follow: 0
  },
  point: 0,
  storeAmount: 0,
  zengAmount: 0,
  totalConsumAmount: 0,
  consultant: '',
  lastConsumAt: '',
  external_userid: '',
  createAt: { time3: '' }
})

const customerSign = ref('')

// 所有点击方法（保持和小程序一致）
const goEditCustomer = () => console.log('编辑客户')
const goCustomerOrderList = () => {

  router.push({
    path: '/orderList',
    query: {
      customer_Id: stateCustomer._id
    }
  })


}
const goCustomerPointList = () => {
  router.push({
    path: '/customerPoint',
    query: {
      id: stateCustomer._id
    }
  })
}
const goCustomerStoreAmountList = () => {
  router.push({
    path: '/storeAmountLog',
    query: {
      id: stateCustomer._id
    }
  })
}
const goCustomerZengAmountList = () => {
  router.push({
    path: '/zengAmountLog',
    query: {
      id: stateCustomer._id
    }
  })
}
const goCustomerCardList = () => {
  router.push({
    path: '/customerCikaList',
    query: {
      id: stateCustomer._id
    }
  })
}
const goCustomerCardList2 = () => {
  router.push({
    path: '/customerDiscountCardList',
    query: {
      id: stateCustomer._id
    }
  })
}
const goCustomerCouponList = () => {
  router.push({
    path: '/customerCouponList',
    query: {
      id: stateCustomer._id
    }
  })
}



const goCustomerSign = () => {
  router.push({
    path: '/signList',
    query: {
      id: stateCustomer._id
    }
  })
}

const goCustomerFolllowLog = () => {


  router.push({
    path: '/followList',
    query: {
      id: stateCustomer._id
    }
  })

}
const goCustomerAppointmentLog = () => {
  router.push({
    path: '/appointmentList',
    query: {
      id: stateCustomer._id
    }
  })
}
const goRecharge = () => {

  router.push({
    path: '/makeRecharge',
    query: {
      id: stateCustomer._id
    }
  })
}
const goSendCard = () => {


  console.log(stateCustomer, 231)
  router.push({
    path: '/sendCard',
    query: {
      id: stateCustomer._id
    }
  })
}
const goSendCoupon = () => {

  router.push({
    path: '/couponSend',
    query: {
      id: stateCustomer._id
    }
  })
}
const goFollow = () => {

  router.push({
    path: '/followAdd',
    query: {
      id: stateCustomer._id
    }
  })
}
const goCasher = () => {


  router.push({
    path: '/choseProduct',
    query: {
      id: stateCustomer._id
    }
  })
}


const loadCustomerInfo = async () => {
  try {
    const db = app.database();
    const shopId = stateShop._id;
    const customerId = stateCustomer._id;
    const res = await db.collection('my_customer')
      .where({ shopId, deleted: 0, _id: customerId })
      .get();

    if (res.data.length > 0) {
      const customerData = res.data[0];
      Object.keys(customerData).forEach(key => {
        if (key in customerInfo) {
          customerInfo[key] = customerData[key];
        }
        if (key in stateCustomer) {
          stateCustomer[key] = customerData[key];
        }
      });
    } else {
      Toast('客户不存在');
    }
  } catch (error) {
    console.error('加载客户信息失败:', error);
    Toast('加载客户信息失败');
  } finally {
    isLoading.value = false;
  }
};

const doWeChatFunRegister = () => {


  ww.register({
    corpId: 'ww9b3595bb7f9bbbed',
    agentId: 1000003,    // 必填，当前用户企业所属企业ID
    jsApiList: ['getCurExternalContact'], // 必填，需要使用的JSAPI列表
    getAgentConfigSignature,
    onAgentConfigSuccess: () => {

      doGetCurrentContact();
    },
    onAgentConfigFail: e => {
      console.log(e, 'fail')
      someWarnInfo.value += JSON.stringify(e);
      Toast('注册过程中出错22');
    }
    // 必填，根据url生成企业签名的回调函数
  })




}

const handleUserActionSelected = async (index) => {


  stateCustomer.name = work_weixin_user.name;
  stateCustomer.avatarUrl = work_weixin_user.avatar;
  stateCustomer.unionid = work_weixin_user.unionid;
  stateCustomer._id = '';
  if (index == 0) {



    router.push({
      path: '/addCustomer',
      query: {
        type: 'add'
      }
    })
  }
  else if (index == 1) {

    router.push({
      path: '/bindCustomer',
      query: {

      }
    })
  }

}


const doGetCurrentContact = async () => {





  let { userId, errCode } = await ww.getCurExternalContact();



  if (errCode !== 0) {
    Toast('获取联系人信息失败');
    return;
  }
  try {
    customerInfo.external_userid = userId;
    const db = app.database();
    let dataList = await db.collection('my_work_weixin_user').where({ external_userid: userId }).get().then(res => {


      return res.data;

    })

    if (dataList.length > 0)
      Object.assign(work_weixin_user, dataList[0]);
    else {

      //不然就从服务器上取一下这个联系人信息并注册 
      let userInfo = await addNewExternalUser(userId);

      Object.assign(work_weixin_user, userInfo);
      someWarnInfo.value += JSON.stringify(work_weixin_user);
    }

    //然后通过unionid 去查一下数据库中是否有这个人
    let customerList = await db.collection('my_customer').where({ unionid: work_weixin_user.unionid, status: 0 }).get().then(res => { return res.data });
    if (customerList.length) {
      Object.assign(customerInfo, customerList[0]);
      Object.assign(stateCustomer, customerList[0]);
    }

    else {


      Object.keys(work_weixin_user).forEach(key => {

        stateCustomer[key] = work_weixin_user[key];

      })

      showUserAction.value = true;

    }
    isLoading.value = false;

  }
  catch (e) {
    someWarnInfo.value += JSON.stringify(e);
  }



}
const addNewExternalUser = async (external_userid) => {

  try {
    const response = await axios.get('/wechat/add_new_external_user', {
      params: { external_userid, user_id: '' }
    })

    someWarnInfo.value += JSON.stringify(response.data.data.external_contact);
    return response.data.data.external_contact;
  } catch (error) {
    console.error('获取签名失败:', error)
    throw error
  }
}
const getAgentConfigSignature = async (url) => {



  try {
    const response = await axios.get('/wechat/config-signature', {
      params: { url }
    })

    const { timestamp, nonceStr, signature } = response.data.data;
    return { timestamp, nonceStr, signature }
  } catch (error) {
    console.error('获取签名失败:', error)
    throw error
  }

}

const initCategoryData = async () => {

  if (stateCategoryList.value.length == 0)
    await app.callFunction({
      name: 'openapi',
      data: {
        action: "getAllCategoryProduct",
        shopId: stateShop._id
      }

    }).then(res => {

      stateCategoryList.value = res.result;


    });
}

const doGetUserInfo = async (userid) => {
  const db = app.database();
  await db.collection('my_user').where({ userid, active: true,shopId:stateShop._id }).field({_id:true,name:true}).get().then(res => {

    if (res.data.length)
  {
    Object.assign(stateUser, res.data[0])
    Toast(`你好，${res.data[0].name}`);
  }
      
    else
      Toast(`店员未找到:${userid}`);
  })

  
}


onMounted(async () => {



  if (!auth.hasLoginState())
    await auth.signInAnonymously();

   someWarnInfo.value += JSON.stringify(route.query);

  if (!stateUser._id) {
    let userid = route.query.userid;
   // Toast(userid)
    doGetUserInfo(userid);
  }

  if (!stateCustomer._id) {
    doWeChatFunRegister();
    return;
  }
  else {
    if (stateReloadCustomer.value)
      loadCustomerInfo();
    else {
      isLoading.value = false;
      Object.assign(customerInfo, stateCustomer);
      stateReloadCustomer.value = false;
    }


  }

  initCategoryData();

})



</script>
<style scoped>
.page {
  padding-bottom: 20vh;
}

.foot-box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  background-color: #fff;
  box-shadow: 0 -2rpx 10rpx rgba(0, 0, 0, 0.1);
  z-index: 999;
}
</style>